import React from 'react'
import styled from 'styled-components'
import { ChevronRight } from 'react-bootstrap-icons'

const Style = styled.div`
  display: flex;
  width: inherit;
  .center {
    flex: 1;
  }
  .place {
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 25px;
    color: #56787d;
  }
  .destination-title {
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 38px;
    color: #3c585f;
  }
  .right-sidebar {
    width: 244px;
    background: #f6f8f9;
    border-radius: 8px;
    padding: 20px 24px 24px 24px;
  }
  .items {
    margin-bottom: 16px;
    a {
      text-decoration: none;
      font-style: normal;
      font-weight: 600;
      font-size: 17px;
      line-height: 25px;
      color: #56787d;
    }
    display: flex;
    align-items: center;
  }
  .Resource-grouping {
    width: 553px;
    display: flex;
    flex-direction: column;
  }
  .Resource-container {
    margin-bottom: 24px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 600px;
  }
  .sub-header {
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 25px;
    color: #3c585f;
  }
  #Resources {
    margin-bottom: 40px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #3c585f;
  }
  .title {
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 38px;
    color: #3c585f;
    padding-top: 24px;
    padding-bottom: 16px;
  }
  .browse.hub-menu {
    box-sizing: border-box;
    width: 220px;
    height: 34px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    letter-spacing: 0.01em;
    cursor: pointer;
    background: white;
    color: #56787d;
    &:hover {
      color: #ff4a6b;
    }
  }
  #browse:hover {
    color: #ff4a6b !important;
  }
`

const ResourceHubMegaMenu = ({ linkData }) => {
  return (
    <Style>
      <div className="center">
        <div className="title">
          <p>{linkData?.header}</p>
        </div>
        <div>
          <div className="Resource-grouping">
            <p id="Resources">{linkData.text}</p>
          </div>
        </div>
        <div
          id="resource-hub-browse"
          className="hover:green-0 flex items-center"
        >
          <a
            href={`${linkData.link}`}
            className="browse hub-menu hover:!text-gray-1100"
          >
            {linkData.button}
            <ChevronRight className="menu-caret ml-5 mt-0.5 size-4" />
          </a>
        </div>
      </div>
    </Style>
  )
}

export default ResourceHubMegaMenu
